import MuiDialogActions, { DialogActionsProps } from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import * as React from 'react';

const StyledActions = styled(MuiDialogActions)(
    ({ theme }) => `
        padding: ${theme.spacing(2)} ${theme.spacing(3)};
    `
);

export const DialogActions: React.FC<DialogActionsProps> = ({ sx, children }) =>
    children ? <StyledActions sx={sx}>{children}</StyledActions> : <></>;
